import _ from 'lodash';
import Vue from 'vue';
import products from '../../api/products';
import * as types from '../mutation-types';

const state = {
  content: {},
  products: [],
  tiers: [],
  loadingProducts: true
};

const getters = {
  LoadingProducts: state => state.loadingProducts,
  ProductList: state => state.products,
  ProductTiers: state => state.tiers,
  ProductsByColour: state => colour => {
    return state.products.filter(provider => provider.colour === colour);
  },
  ProductsByProvider: state => id => {
    if (id) {
      return state.products.filter(product => product.business_id === id);
    } else {
      return state.products;
    }
  },
  ProductContent: state => productId => state.content[productId],
  RedProducts: state =>
    _.filter(state.products, product => product.colour === 'red' && product.invisible_provider !== 1),
  AmberProducts: state =>
    _.filter(state.products, product => product.colour === 'amber' && product.invisible_provider !== 1),
  GreenProducts: state =>
    _.filter(state.products, product => product.colour === 'green' && product.invisible_provider !== 1),
  HiddenProducts: state => _.filter(state.products, product => product.invisible_provider === 1),
  SelectedProducts: state => state.products.filter(provider => provider.selected === true)
};

const actions = {
  startLoadingProducts({ commit }) {
    return new Promise(resolve => {
      commit(types.START_LOADING_PRODUCTS);
      resolve();
    });
  },
  stopLoadingProducts({ commit }) {
    return new Promise(resolve => {
      commit(types.STOP_LOADING_PRODUCTS);
      resolve();
    });
  },
  getAllProducts({ commit, dispatch }, id) {
    dispatch('startLoadingProducts');
    products
      .getProducts(id)
      .then(productList => {
        commit(types.SET_PRODUCT_SET, { productList });
        dispatch('stopLoadingProducts');
      })
      .catch(error => console.log(error));
  },
  updateProduct({ commit }, { id, updates }) {
    products
      .updateProduct(id, updates)
      .then(response => {
        commit(types.SET_UPDATE_PRODUCT, response.data);
      })
      .catch(error => console.log(error));
  },
  addProduct({ dispatch }, product) {
    products
      .addProduct(product)
      .then(() => {
        dispatch('getFundersList');
      })
      .catch(error => console.log(error));
  },
  async getProductContent({ commit }, productId) {
    const content = await products.getProductContent(productId);
    commit(types.SET_PRODUCT_CONTENT, { productId, content });
  },
  updateProductColours({ commit }, { productList }) {
    commit(types.SET_PRODUCT_SET, { productList });
  },
  toggleProductSelect({ commit }, { productId, selected }) {
    commit(types.TOGGLE_PRODUCT_SELECT, { productId, selected });
  },
  removeProductFromProductSet({ commit }, { productId }) {
    commit(types.REMOVE_PRODUCT_FROM_PRODUCT_SET, { productId });
  },
  getProductTiers({ commit }) {
    return products.getProductTiers().then(({ data }) => commit(types.SET_PRODUCT_TIERS, { tiers: data }));
  }
};

const mutations = {
  [types.START_LOADING_PRODUCTS](state) {
    state.loadingProducts = true;
  },
  [types.STOP_LOADING_PRODUCTS](state) {
    state.loadingProducts = false;
  },
  [types.SET_PRODUCT_SET](state, { productList }) {
    state.products = productList;
  },
  [types.CLEAR_PRODUCTS](state) {
    state.products = [];
  },
  [types.REMOVE_PRODUCT_FROM_PRODUCT_SET](state, { productId }) {
    const record = _.find(state.products, product => product.id === productId);
    if (record) {
      state.products.splice(state.products.indexOf(record), 1);
    }
  },
  [types.SET_UPDATE_PRODUCT](state, response) {
    const record = _.find(state.products, product => product.id === response.id);
    _.merge(record, response);
  },
  [types.UPDATE_PRODUCT_COLOURS](state, { product, colour }) {
    product.colour = colour;
  },
  [types.TOGGLE_PRODUCT_SELECT](state, { productId, selected }) {
    const record = _.find(state.products, product => product.id === productId);
    record.selected = selected;
  },
  [types.SET_PRODUCT_TIERS](state, { tiers }) {
    state.tiers = tiers;
  },
  [types.SET_PRODUCT_CONTENT](state, { productId, content }) {
    Vue.set(state.content, productId, content);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
